<ng-container *ngIf="renderHTML">
  <object *ngIf="safeUrl" [data]="safeUrl" type="application/pdf" width="100%" [height]="height"></object>
  <ng-content></ng-content>
</ng-container>
